import { Skeleton } from '../components/ui/skeleton';

/**
 * Detail-page skeleton for mobile module detail views. Renders a hero, a
 * title/subtitle stack, and a few paragraph blocks — enough to establish
 * layout and signal that real content is on the way.
 *
 * `hero` controls the hero shape:
 *   - `wide`   — 16:9 banner (News, Video, Event)
 *   - `square` — centred 160px square (Podcast series, Podcast episode)
 *   - `book`   — 140×210 book cover
 *   - `avatar` — centred 56px circle + centred title (Circle)
 *   - `none`   — no hero
 */
export function DetailSkeleton({
  hero = 'wide',
}: {
  hero?: 'wide' | 'square' | 'book' | 'avatar' | 'none';
}) {
  return (
    <article className="px-4 pt-4 pb-10 space-y-5">
      {hero === 'wide' && <Skeleton className="aspect-[16/9] w-full rounded-lg" />}
      {hero === 'square' && (
        <div className="flex justify-center">
          <Skeleton className="w-40 h-40 rounded-xl" />
        </div>
      )}
      {hero === 'book' && (
        <div className="flex justify-center">
          <Skeleton className="w-[140px] h-[210px] rounded-md" />
        </div>
      )}
      {hero === 'avatar' && (
        <div className="flex flex-col items-center gap-3">
          <Skeleton className="w-14 h-14 rounded-full" />
          <Skeleton className="h-5 w-[60%]" />
          <Skeleton className="h-3 w-[40%]" />
        </div>
      )}

      {hero !== 'avatar' && (
        <div className="space-y-3">
          <Skeleton className="h-7 w-[90%]" />
          <Skeleton className="h-7 w-[60%]" />
          <Skeleton className="h-4 w-[40%]" />
        </div>
      )}

      <div className="space-y-2 pt-1">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[70%]" />
      </div>

      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[85%]" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[50%]" />
      </div>
    </article>
  );
}
